import { useState } from 'react';
import {
  CompassCardComponent,
  CompassCardComponentProps,
} from 'react-scale/corp/views/DataCompassV2/types';
import useContributorScreeningsAdapterCard from './useContributorScreeningsAdapterCard';
import { TextArea, FormField, Box } from '@scale/scaleui-radix';
import { twMerge } from 'tailwind-merge';
import { compassErrorClassName } from 'react-scale/corp/views/DataCompassCardsV2/utils';

const ContributorScreeningsAdapterCardComponent: CompassCardComponent = ({
  index,
}: CompassCardComponentProps) => {
  const { query, setQuery, hasError } = useContributorScreeningsAdapterCard(index);

  const [searchInput, setSearchInput] = useState<string>(query ?? '');

  const onSearchInputChange = (input: string) => {
    setSearchInput(input);
    setQuery(input);
  };

  return (
    <div className="p-4">
      <div className="space-y-4 mb-3">
        <Box pt="4">
          <FormField.Root size="3">
            <FormField.Label htmlFor="contributors-screening-textarea">Query</FormField.Label>
            <TextArea
              id="search-textarea"
              placeholder="Harvard grad who knows Python"
              value={searchInput}
              onChange={e => onSearchInputChange(e.target.value)}
              className={twMerge('rounded-sm', hasError && !searchInput && compassErrorClassName)}
            />
          </FormField.Root>
        </Box>
      </div>
    </div>
  );
};

export default ContributorScreeningsAdapterCardComponent;
